var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"popin\" ng-class=\"popinClass()\"\u003E\u003Ci class=\"fa fa-close fa-2x close-modal close-modal-beige\" ng-click=\"popin.isDisplay = false\"\u003E\u003C\u002Fi\u003E\u003Cng-transclude\u003E\u003C\u002Fng-transclude\u003E\u003Cdiv class=\"popin-fold-button\" ng-click=\"popin.isFold = !popin.isFold\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/directives/popin/popin.jade
// module id = 746
// module chunks = 1